import React from "react";
import { Briefcase, GraduationCap, Clock, Mail, Bell, Users, Calendar, FileText } from "lucide-react";

export default function CareerPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 pt-9">
      {/* Hero Section */}
      <section className="text-center px-6 py-20 bg-gradient-to-b from-indigo-600/20 to-gray-950">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Careers at Our Company
        </h1>
        <p className="text-gray-300 max-w-2xl mx-auto">
          While we don't have any active openings right now, we're always interested 
          in connecting with talented individuals for future opportunities.
        </p>
      </section>

      {/* Current Status */}
      <section className="px-6 py-12 max-w-4xl mx-auto">
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 border border-gray-700 rounded-2xl p-8 md:p-10 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-800 rounded-full mb-6">
            <Briefcase className="w-10 h-10 text-gray-400" />
          </div>
          <h2 className="text-3xl font-semibold mb-4">No Active Openings</h2>
          <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto">
            We currently don't have any job openings or internship positions available. 
            All our positions are filled at the moment.
          </p>
          <div className="inline-flex items-center gap-2 text-gray-400 bg-gray-800/50 px-4 py-2 rounded-lg">
            <Calendar size={18} />
            <span>Check back later for future opportunities</span>
          </div>
        </div>
      </section>

      {/* Why Join Us - Future */}
      <section className="px-6 py-16 max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-12">
          Future Opportunities
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-900 p-6 rounded-2xl shadow-lg border border-gray-800">
            <GraduationCap className="w-10 h-10 text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Internship Programs</h3>
            <p className="text-gray-400">
              We occasionally offer internship opportunities for students and freshers.
            </p>
          </div>
          <div className="bg-gray-900 p-6 rounded-2xl shadow-lg border border-gray-800">
            <Briefcase className="w-10 h-10 text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Full-time Roles</h3>
            <p className="text-gray-400">
              Technical and non-technical positions based on company growth.
            </p>
          </div>
          <div className="bg-gray-900 p-6 rounded-2xl shadow-lg border border-gray-800">
            <Clock className="w-10 h-10 text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Project-based Work</h3>
            <p className="text-gray-400">
              Short-term contract opportunities for specific projects.
            </p>
          </div>
        </div>
      </section>

      {/* Stay in Touch */}
      <section className="px-6 py-16 bg-gray-900/40">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-gray-950 border border-gray-800 rounded-2xl p-8 mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-600/20 rounded-full mb-6">
              <Bell className="w-8 h-8 text-indigo-400" />
            </div>
            <h3 className="text-2xl font-semibold mb-4">Get Notified</h3>
            <p className="text-gray-400 mb-6">
              Want to be the first to know when we have new openings? 
              Subscribe to our career alerts.
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="Your email address"
                className="flex-1 px-4 py-3 bg-gray-900 border border-gray-700 rounded-xl focus:outline-none focus:border-gray-600"
                required
              />
              <button 
                type="submit"
                className="px-6 py-3 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-xl font-medium"
              >
                Subscribe
              </button>
            </form>
          </div>
          
          <div className="bg-gray-950 border border-gray-800 rounded-2xl p-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-800 rounded-full mb-6">
              <FileText className="w-8 h-8 text-gray-400" />
            </div>
            <h3 className="text-2xl font-semibold mb-4">Spontaneous Application</h3>
            <p className="text-gray-400 mb-6">
              Even without active openings, you can send us your resume. 
              We'll keep it on file for future opportunities.
            </p>
            <button className="px-8 py-3 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-xl font-medium flex items-center gap-2 mx-auto">
              <Mail size={18} />
              Submit Your Resume
            </button>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="px-6 py-12 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-semibold mb-6">Contact Our HR Team</h2>
          <p className="text-gray-400 mb-8">
            For any career-related inquiries, you can reach out to us at:
          </p>
          <div className="bg-gray-900/50 p-6 rounded-xl border border-gray-800 inline-block">
            <p className="text-gray-300 mb-2">
              <span className="text-gray-500">Email:</span> cyber.edge@yandex.com
            </p>
            {/* <p className="text-gray-300">
              <span className="text-gray-500">Phone:</span> +91 XXX XXX XXXX
            </p> */}
          </div>
          
        </div>
      </section>
    </div>
  );
}